import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const FormSelect = ({
  label,
  name,
  options = [],
  placeholder = 'Select an option',
  required = false,
  disabled = false,
  error = null,
  hasError = false,
  helpText = null,
  className = '',
  selectClassName = '',
  labelClassName = '',
  ...props
}) => {
  const { theme } = useTheme();
  
  const baseSelectClasses = `
    w-full px-3 py-2 border rounded-lg 
    focus:outline-none focus:ring-2 focus:ring-teal-500 
    disabled:opacity-50 disabled:cursor-not-allowed
    transition-colors duration-200
    ${theme === 'dark' 
      ? 'bg-gray-700 text-white' 
      : 'bg-white text-gray-900'
    }
  `;

  const errorClasses = hasError 
    ? 'border-red-500 focus:ring-red-500' 
    : theme === 'dark' 
      ? 'border-gray-600' 
      : 'border-gray-300';
  const selectClasses = `${baseSelectClasses} ${errorClasses} ${selectClassName}`;

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label 
          htmlFor={name} 
          className={`block text-sm font-medium ${
            theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
          } ${labelClassName}`}
        >
          {label}
          {required && <span className="text-red-400 ml-1">*</span>}
        </label>
      )}
      
      <select
        id={name}
        name={name}
        required={required}
        disabled={disabled}
        className={selectClasses}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option 
            key={option.value} 
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
      
      {helpText && !error && (
        <p className={`text-xs ${
          theme === 'dark' ? 'text-gray-400' : 'text-gray-500'
        }`}>{helpText}</p>
      )}
      
      {error && (
        <p className="text-sm text-red-400 flex items-center">
          <svg className="w-4 h-4 mr-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export default FormSelect;
